module.exports = __webpack_public_path__ + "static/images/txcz-qq-code.7a77584.png";